
export const LOCALSTORAGE_KEY = "bilan";